import { inject, Injectable } from "@angular/core";

import {
  AutoRedemptionTestStatePatch,
  AutoRedemptionTestStateResponse,
} from "@bitwarden/web-vault/app/models/types/auto-redemption-test-state.types";
import { SubscriptionConfigType } from "@bitwarden/web-vault/app/models/types/environement-config.type";
import { DataRepositoryService } from "@bitwarden/web-vault/app/services/DataRepository/data-repository.service";

const SUBSCRIPTION_CONFIG = process.env.SUBSCRIPTION as unknown as SubscriptionConfigType;

@Injectable({
  providedIn: "root",
})
export class AutoRedemptionTestStateService {
  private dataRepository = inject(DataRepositoryService);

  getState(): Promise<AutoRedemptionTestStateResponse> {
    return this.request<AutoRedemptionTestStateResponse>(
      "GET",
      SUBSCRIPTION_CONFIG.endpoint.auto_redemption_test_state,
    );
  }

  saveState(patch: AutoRedemptionTestStatePatch): Promise<AutoRedemptionTestStateResponse> {
    return this.request<AutoRedemptionTestStateResponse>(
      "PATCH",
      SUBSCRIPTION_CONFIG.endpoint.auto_redemption_test_state,
      patch,
    );
  }

  private subscriptionApiBase(): string {
    const stage = SUBSCRIPTION_CONFIG.apiStage;
    if (stage) {
      return `${SUBSCRIPTION_CONFIG.url}/${stage}`.replace(/\/$/, "");
    }
    return SUBSCRIPTION_CONFIG.url.replace(/\/$/, "");
  }

  private request<T>(method: "GET" | "PATCH", path: string, body: unknown = null): Promise<T> {
    return this.dataRepository.send(method, path, body, true, true, this.subscriptionApiBase());
  }
}
